import {RequisitionItem} from "../redux/vmsApi";
import { parseQuantity } from './quantityUtil';

export function calculateTotalWithoutDiscount(items: RequisitionItem[]) {
  return items.reduce((acc: number, item: any) => {
    const baseCost = parseQuantity(item.quantity.quantityValue) * item.rate;
    const VAT = item.VAT ? 0.15 * item.rate * parseQuantity(item.quantity.quantityValue) : 0;
    return acc + baseCost + VAT;
  }, 0);
}


export function calculateTotalWithDiscount(items: RequisitionItem[], globalDiscount: number) {
  const totalWithoutDiscount = calculateTotalWithoutDiscount(items);
  const totalCostSum = items.reduce((acc: number, item: any) => acc + (item.totalCostPerItem || 0), 0);
  return globalDiscount > 0 ? totalWithoutDiscount - globalDiscount : totalCostSum;
}